import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.clickOutsideHandler = (event) => {
      if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
        if (!this.menuTarget.contains(event.target) && !event.target.closest(".cell-menu-trigger")) {
          this.close()
        }
      }
    }
    document.addEventListener("click", this.clickOutsideHandler)

    this.scrollHandler = () => this.close()
    window.addEventListener("scroll", this.scrollHandler, true)
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
    window.removeEventListener("scroll", this.scrollHandler, true)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const menu = this.menuTarget

    const categoryId = button.dataset.categoryId
    const month = button.dataset.month
    const session = button.dataset.session
    const count = button.dataset.issueCount || "0"
    const locale = new URLSearchParams(window.location.search).get("locale") || ""
    const localeParam = locale ? `locale=${locale}` : ""
    
    menu.querySelector("#cell-menu-issue-count").textContent = count
    menu.querySelector("#cell-menu-issues-link").href =
      `/categories/${categoryId}/issues?month=${month}&session=${session}&${localeParam}`
    menu.querySelector("#cell-menu-add-issue").href =
      `/categories/${categoryId}/issues/new?month=${month}&session=${session}&${localeParam}`    
    const rect = button.getBoundingClientRect()

    menu.style.visibility = "hidden"
    menu.classList.remove("hidden")
    const menuWidth = menu.offsetWidth
    const menuHeight = menu.offsetHeight
    menu.classList.add("hidden")
    menu.style.visibility = ""

    let top = rect.bottom + 4
    let left = rect.right - menuWidth

    if (top + menuHeight > window.innerHeight) {
      top = rect.top - menuHeight - 4
    }
    if (left < 8) {
      left = 8
    }

    menu.style.top = `${top}px`
    menu.style.left = `${left}px`
    menu.classList.remove("hidden")
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
  }
}
